import { makeAutoObservable, runInAction } from 'mobx';

import { cmApi } from '@src/api';
import type { CmApi, MonthDto } from '@src/api';

import { preloaderStore } from '../../preloaderStore';

type MonthDtoDefId = MonthDto & { id: number };

class MonthsStore {
  months: MonthDtoDefId[] = [];

  api: CmApi;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  fetch = async (): Promise<void> => {
    preloaderStore.preloader(true);
    const { data } = await this.api.month.getMonths();
    runInAction(() => {
      this.months = data?.map((month) => ({ ...month, id: month.code ?? -1 })) ?? [];
    });
    preloaderStore.preloader(false);
  };
}

export const monthsStore = new MonthsStore({ api: cmApi });
